import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Layout, Spin } from "antd";
import Header from "./components/Header";
import AdminPage from "./pages/AdminPage";
import UpworkCallbackPage from "./pages/UpworkCallbackPage";
import MovedPage from "./pages/MovedPage";
import Footer from "./components/Footer";
import posthog from 'posthog-js';
import { AUTH0_TOKEN_ROLES_CLAIM, ROLES } from "./config";
import ErrorBoundary from "./components/ErrorBoundary";
import { isSessionInvalidError, logoutToHome } from "./utils/authSession";

const { Content } = Layout;

const App = () => {
  const { isAuthenticated, user, isLoading, getAccessTokenSilently, logout } = useAuth0();
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (user) {
      const getRole = () => {
        if (user && user[AUTH0_TOKEN_ROLES_CLAIM]) {
          return user[AUTH0_TOKEN_ROLES_CLAIM][0];
        }
        return null;
      };
      const userRole = getRole();
      setRole(userRole);

      posthog.identify(user.sub, {
        email: user.email,
        role: userRole,
      });
    }
  }, [user]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const validateSession = async () => {
      try {
        await getAccessTokenSilently();
      } catch (error) {
        if (isSessionInvalidError(error)) {
          logoutToHome(logout);
        } else {
          console.error("Session validation failed:", error);
        }
      }
    };

    validateSession();
  }, [isAuthenticated, getAccessTokenSilently, logout]);

  if (isLoading) {
    return <Spin tip="Loading..." />;
  }

  return (
    <Router>
      <Layout style={{ minHeight: "100dvh" }}>
        <Header />
        <Content style={{ flex: 1 }}>
          {!isAuthenticated && <MovedPage />}
          {isAuthenticated && role === ROLES.ADMIN && (
            <ErrorBoundary>
              <Routes>
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/" element={<Navigate to="/admin" />} />
                <Route
                  path="/upwork_callback"
                  element={<UpworkCallbackPage />}
                />
                <Route path="*" element={<Navigate to="/admin" />} />
              </Routes>
            </ErrorBoundary>
          )}
          {isAuthenticated && role !== ROLES.ADMIN && (
            <MovedPage />
          )}
        </Content>
        <Footer />
      </Layout>
    </Router>
  );
};

export default App;
